

export const SETTINGS_TYPES = {
    GENERAL: 'general',
    GRAPH: 'graph',
    STATUS: 'status'
}